// HttpService.js
import axios from "axios";
import store from "../store";
import { notification } from "ant-design-vue";
import { showApiError } from "@/utils";

// const _token = localStorage.getItem('token');
const pendingRequests = new Map();

// Generate a unique key for each request
const generateRequestKey = (config) => {
  const { method, url, params = {}, data } = config;
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join("&");
};
const HttpService = axios.create({
  baseURL: window.APP_CONFIG?.serverIp || process.env.VUE_APP_SERVER_IP,
  headers: {
    "Content-Type": "application/json",
    //'Authorization': `Bearerss ${_token}`
    // You may include additional headers as needed
  },
  timeout: 30000,
  // timeout: 6000,`
});

HttpService.interceptors.response.use(
  function (response) {
    if (
      (response.config.method === "delete" ||
        response.config.method === "post" ||
        response.config.method === "put") &&
      response.config.url !== "/employees-list"
    ) {
      setTimeout(() => {
        // Get all button elements on the page
        const buttons = document.querySelectorAll("button");
        // Loop through each button and disable it
        buttons.forEach((button) => {
          // console.log(button, button.textContent, button.innerText)
          const buttonText = button.innerText.toLocaleLowerCase();

          if (
            buttonText.includes("submit") ||
            buttonText.includes("update") ||
            buttonText.includes("add")
          ) {
            button.disabled = false;
          }
        });
      }, 2000);
    }

    return response;
  },
  function (error) {
    setTimeout(() => {
      // Get all button elements on the page
      const buttons = document.querySelectorAll("button");

      // Loop through each button and disable it
      buttons.forEach((button) => {
        // console.log(button, button.textContent, button.innerText)
        const buttonText = button.innerText.toLocaleLowerCase();

        if (
          buttonText.includes("submit") ||
          buttonText.includes("update") ||
          buttonText.includes("add")
        ) {
          button.disabled = false;
        }
      });
    }, 2000);

    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } 

    if (error.code === "ECONNABORTED") {
      console.log('ECONNABORTED', error)
      notification.open({
        message: "Request timed out. Please try again.",
        placement: "topRight",
        duration: 3,
      });
    }

    if (error.response && error.response.status === 429) {
      notification.open({
        message: "Too many requests. Please wait a moment and try again.",
        placement: "topRight",
        duration: 3,
      });
    }

    // unAuth handling
    if (error.response && error.response.status === 401) {
      const token = localStorage.getItem("token");
      if (token) {
        store.dispatch("auth/loading", true)
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/";
      } else {
        return
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

//Add an interceptor to include the bearer token in the headers for every request except /login
HttpService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    //const token  = '14|EjLXuUah9fUyWkywvZzTjT1aQt8FHAMKgqFl6RJnba69e6d9'
    // Check if the request is not for /login before adding the token to headers
    if (token && !config.url.endsWith("/login")) {
      //console.log('http service condition',token);
      // 13|bLwvCJ2Peyq7Rs6MwItNR80WqFHCAcwDfVlIeCM43e2c0725
      // token  = '13|bLwvCJ2Peyq7Rs6MwItNR80WqFHCAcwDfVlIeCM43e2c0725
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (
      (config.method === "delete" ||
        config.method === "post" ||
        config.method === "put") &&
      config.url !== "/employees-list"
    ) {
      // Get all button elements on the page
      const buttons = document.querySelectorAll("button");

      //  Loop through each button and disable it
      buttons.forEach((button) => {
        // console.log(button, button.textContent, button.innerText)
        const buttonText = button.innerText.toLocaleLowerCase();

        if (
          buttonText.includes("submit") ||
          buttonText.includes("update") ||
          buttonText.includes("add")
        ) {
          button.disabled = true;
        }
      });
    } else {
    }
    // return config;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default HttpService;